import React, { useMemo } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const HockeyMatchGameSpecial = observer(({ item }) => {
  const { special } = item;

  return (
    <div className="special_board">
      <dl className="item">
        <dt>첫득점</dt>
        <dd className={clsx(special.firstPoint === 'AWAY' && 'on')}></dd>
        <dd className={clsx(special.firstPoint === 'HOME' && 'on')}></dd>
      </dl>
      <dl className="item">
        <dt>첫파플</dt>
        <dd className={clsx(special.firstPower === 'AWAY' && 'on')}></dd>
        <dd className={clsx(special.firstPower === 'HOME' && 'on')}></dd>
      </dl>
    </div>
  );
});

export default HockeyMatchGameSpecial;
